<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            placeholder="Tìm kiếm theo ID báo giá, khách hàng, sản phẩm" 
            :orderbutton="true"
            :listStatus="QUOTE_STATUS_LIST"
            :orderSummary="summary"
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-' + item.ID">
                <td>{{ item.ID }}</td>
                <td>{{ item.Username }}</td>
                <td>{{ item.FullName }}</td>
                <td>{{ item.ProductName }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, QUOTE_STATUS_LIST)}">{{ item.Status | display_value(QUOTE_STATUS_LIST) }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.OrderType, QUOTE_TYPE_LIST)}">{{ item.OrderType | display_value(QUOTE_TYPE_LIST) }}</td>
                <td>{{ item.ChinaStoreID | display_value(china_stores) }}</td>
                <td>{{ item.ReceivePlaceID | display_value(vn_stores) }}</td>
                <td>{{ (item.ModifiedDate || item.CreatedDate) | display_date }}</td>
                <td>{{ item.CreatedBy }}</td>
                <td>{{ item.ModifiedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">fa-edit</v-icon>
                  <v-icon medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
  },
  data() {
    return {
      QUOTE_STATUS_LIST: configs.QUOTE_STATUS,
      QUOTE_TYPE_LIST: configs.QUOTE_TYPE,
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "quotes_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."]
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    }
  },
  computed: {
    ...mapState({
    items: (state) => state.quotes.all.data,
    summary: (state) => state.quotes.summary,
    total_rows: (state) => state.quotes.all.total,
    loading: (state) => state.quotes.loading,
    vn_stores: state => _.map(state.commons.stores, (item) => {
      return {
          value: item.ID,
          name: item.Name
      }
    }),
    china_stores: state => _.map(state.commons.chinaStores, (item) => {
      return {
          value: item.ID,
          name: item.Name
      }
    }),
    currentPath() {
      return this.$route.path;
    },
  }),

  headers() {
    let tmp = [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên khách",
          value: "FullName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên sản phẩm",
          value: "ProductName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.QUOTE_STATUS,
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "Cách chia đơn",
          value: "OrderType",
          filterable: true,
          values: configs.QUOTE_TYPE,
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "Kho gửi",
          value: "ChinaStoreID",
          filterable: true,
          values: this.china_stores,
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "Kho nhận",
          value: "ReceivePlaceID",
          filterable: true,
          values: this.vn_stores,
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "Ngày sửa",
          value: "ModifiedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"],
        },
        {
          text: "Người tạo",
          value: "CreatedBy",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Người sửa",
          value: "ModifiedBy",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          width: 100,
          sortable: false,
          filterable: false,
        },
      ];
      return tmp;
    }
  },
  methods: {
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
      };
      this.$store.dispatch("quotes/getList", param);
      this.$store.dispatch("quotes/getSummary");
    },
    gotoDetail: function (id) {
      this.$router.push({
        name: "QuoteDetail",
        params: {
          Pid: id,
          title: `Chi tiết báo giá (#${id})`,
        },
      });
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData() {
      this.$store.commit("quotes/setDetail", {data: {}});
      this.$router.push({
        name: "QuoteDetail",
        params: {
          Pid: "tao-moi",
          title: `Tạo mới báo giá`,
        },
      });
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    }
  },
  mounted() {
    this.$store.dispatch("commons/getAllStores");
    this.$store.dispatch("commons/getAllChinaStores");
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
      this.$store.dispatch("quotes/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA");
    this.$root.$off("REQUEST_REFRESH_DATA");
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  },
};
</script>
